import { Route } from "react-router-dom";
import { Helmet } from "react-helmet-async";
import { FAMILY_ROUTES } from "@/shared/constants/paths";

// Family Pages
import AcceptInvitationPage from "@/pages/family/accept-invitation/AcceptInvitationPage";
import { ClientInvitePage } from "@/pages/client-invite/ClientInvitePage";
import { ClientInviteSignupPage } from "@/pages/client-invite/ClientInviteSignupPage";

export const familyRoutes = (
  <>
    <Route
      path={FAMILY_ROUTES.ACCEPT_INVITATION}
      element={
        <>
          <Helmet>
            <title>Accept Family Invitation - Elayne</title>
          </Helmet>
          <AcceptInvitationPage />
        </>
      }
    />
    <Route
      path={FAMILY_ROUTES.CLIENT_INVITE}
      element={
        <>
          <Helmet>
            <title>Accept Invitation - Elayne</title>
          </Helmet>
          <ClientInvitePage />
        </>
      }
    />
    <Route
      path={FAMILY_ROUTES.CLIENT_INVITE_SIGNUP}
      element={
        <>
          <Helmet>
            <title>Create Account - Elayne</title>
          </Helmet>
          <ClientInviteSignupPage />
        </>
      }
    />
  </>
);
